import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com', 's5-tech.com']

@Component({
  selector: 'app-renderlog',
  templateUrl: './renderlog.component.html',
  styleUrls: ['./renderlog.component.css']
})
export class RenderlogComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  renderlogs: any = {}
  logsFlattened: any = {}
  logsFlattenedDisplay: any = {}

  constructor(injector: Injector) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  async refresh() {
    await this.getData()
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    this.loader.show()
    const renderlogsRef = ref(this.database, 'renderlogs');
    const snapshot = await get(renderlogsRef);
    if (snapshot.exists()) {
      this.renderlogs = snapshot.val();
      this.logsFlattened = this.flattenObject(this.renderlogs)
      this.logsFlattenedDisplay = this.logsFlattened
    }
    this.loader.hide()
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }

  flattenObject(obj: any): any {
    let array: any = []
    for (let key in obj) { // scenarioname
      if (obj[key] && typeof obj[key] === 'object') {
        for (let key2 in obj[key]) { // playername
          for (let key3 in obj[key][key2]) { // date
            for (let key4 in obj[key][key2][key3]) { // time
              let record: any = { scenarioname: key, playername: key2, date: key3, time: key4, log:  obj[key][key2][key3][key4] }
              array.push(record)
            }
          }
        }
      }
    }
    return array
  }
  deleteScenario(scenarioname: any) {
    this.renderlogs[scenarioname] = null
    // update renderlogs to firebase database
    const renderlogsRef = ref(this.database, 'renderlogs');
    update(renderlogsRef, this.renderlogs);
  }
  filterDateAndScenario(scenarioname: any, date: any) {
    this.logsFlattenedDisplay = this.logsFlattened.filter((log: any) => log.scenarioname == scenarioname && log.date == date)
  }
  clearFilter(){
    this.logsFlattenedDisplay=this.logsFlattened
  }
}
